import { formatRupiahDot } from "../../lib/format";

/** Read-only renderer for an AI custom_table (used in chat card & letterhead). */
export default function CustomTableView({ table, compact = false, testIdPrefix = "custom" }) {
  const nominal = new Set(table.kolom_nominal || []);
  const cell = (v, i) => {
    if (nominal.has(i)) return formatRupiahDot(Number(v) || 0);
    return v === null || v === undefined ? "" : String(v);
  };
  const cls = compact ? "text-xs" : "text-[13px]";
  return (
    <table className={`w-full border-collapse ${cls} tabular-nums`} data-testid={`${testIdPrefix}-table`}>
      <thead>
        <tr>
          {table.kolom.map((k, i) => (
            <th
              key={i}
              className={`border border-slate-800 px-2 py-1.5 font-bold bg-slate-100 ${
                nominal.has(i) ? "text-right" : "text-left"
              }`}
            >
              {k}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {table.baris.map((row, r) => (
          <tr key={r} data-testid={`${testIdPrefix}-row-${r}`}>
            {row.map((v, i) => (
              <td
                key={i}
                className={`border border-slate-800 px-2 py-1 ${nominal.has(i) ? "text-right" : ""}`}
              >
                {cell(v, i)}
              </td>
            ))}
          </tr>
        ))}
        <tr data-testid={`${testIdPrefix}-total`}>
          <td
            colSpan={Math.max(1, table.kolom.length - 1)}
            className="border border-slate-800 px-2 py-1.5 font-black text-right"
          >
            {table.total_label || "TOTAL"}
          </td>
          <td className="border border-slate-800 px-2 py-1.5 font-black text-right">
            {formatRupiahDot(table.grand_total || 0)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
